module.exports = "/images/ListChecks.svg";